import { render } from "./GoodsReceiptUpdate.vue?vue&type=template&id=64e83f2a&scoped=true"
import script from "./GoodsReceiptUpdate.vue?vue&type=script&lang=js"
export * from "./GoodsReceiptUpdate.vue?vue&type=script&lang=js"

import "./GoodsReceiptUpdate.vue?vue&type=style&index=0&id=64e83f2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e83f2a"]])

export default __exports__